import React, { useCallback, useEffect, useState } from 'react';

import DateFnsUtils from '@date-io/date-fns';

import { makeStyles }   from '@material-ui/core/styles';
import AppBar           from '@material-ui/core/AppBar';
import Button           from '@material-ui/core/Button';
import Dialog           from '@material-ui/core/Dialog';
import DialogActions    from '@material-ui/core/DialogActions';
import DialogContent    from '@material-ui/core/DialogContent';
import Divider          from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton       from '@material-ui/core/IconButton';
import Radio            from '@material-ui/core/Radio';
import Table            from '@material-ui/core/Table';
import TableBody        from '@material-ui/core/TableBody';
import TableCell        from '@material-ui/core/TableCell';
import TableContainer   from '@material-ui/core/TableContainer';
import TablePagination  from '@material-ui/core/TablePagination';
import TableRow         from '@material-ui/core/TableRow';
import Tab              from '@material-ui/core/Tab';
import Tabs             from '@material-ui/core/Tabs';
import TextField        from '@material-ui/core/TextField';
import Typography       from '@material-ui/core/Typography';

import OpenInNewIcon     from '@material-ui/icons/OpenInNew';

import Pagination from '@material-ui/lab/Pagination';

import { KeyboardDateTimePicker }  from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { IssuedTicket } from '../ticket';
import { countByTicket, create, date } from '../util';
import UsedTicketsToAttend from './UsedTicketsToAttend';

const style = {
  quickAttending: makeStyles((theme) => ({
    appBarAttender: {
      alignItems: 'center',
      display: 'flex',
      gap: theme.spacing(2),
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
    appBarAttenderInfo: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
    appBarAttenderPicture: {
      borderRadius: '50%',
    },
  })),
  quickPayments: makeStyles((theme) => ({
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      paddingTop: theme.spacing(4),
    },
    note: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    }
  })),
  ticketsToAttend: makeStyles((theme) => ({
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      paddingTop: theme.spacing(4),
    },
    formControlLabel: {
      marginLeft: theme.spacing(0),
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
    },
    ticket: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
      whiteSpace: 'nowrap',
    },
  })),
};

function QuickPayments(props) {
  const classes = style.quickPayments();

  const { request, ticketDetail } = props.context.getStates();

  const [ count, setCount ] = useState(0);
  const [ page, setPage ] = useState(0);
  const [ payments, setPayments ] = useState([]);

  const fetchPayments = useCallback((page) => {
    request.postSecurely('/attender/paid', {
      attender: props.attender.rowid, page,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        if ('count' in response) {
          setCount(response.count);
        }
        if ('paidHistory' in response) {
          setPayments(response.paidHistory);
        }
      }
    });
  }, [
    props.attender.rowid,
    request,
  ]);


  useEffect(() => {
    fetchPayments(0);
  }, [
    fetchPayments,
  ])

  return (<>
    <DialogContent className={classes.dialogContent}>
      <TableContainer>
        <Table>
          <TableBody>
            {payments.map((paid) =>
              <TableRow hover key={paid.rowid}>
                <TableCell style={{whiteSpace: 'nowrap'}}>
                  <div>
                    {date.withDay(paid.date)}
                  </div>
                  <div>
                    {`${paid.amount.toLocaleString()} ${paid.currency}`} ({`${paid.method}`})
                  </div>
                </TableCell>
                <TableCell>
                  {Object.keys(ticketDetail).length > 0 && countByTicket(paid.issued).map((
                    ticketCounted, index
                  ) => (
                    <div key={index} style={{paddingRight: '10px', whiteSpace: 'nowrap'}}>
                      <b>{ticketDetail[ticketCounted[0]].name}</b> &times; {ticketCounted[1]}장
                    </div>
                  ))}
                  {paid.note !== '' && (<>
                    <Divider className={classes.note} />
                    <div>
                      {paid.note.split('\n').map((line, index) => (
                        <Typography variant="body1" key={index}
                          color="textSecondary"
                        >{line}</Typography>
                      ))}
                    </div>
                  </>)}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination page={page} count={count}
        component="div"
        onPageChange={(event, newPage) => { setPage(newPage); }}
        rowsPerPage={5}
        rowsPerPageOptions={[]}
      />
    </DialogContent>

    <DialogActions>
      <Button onClick={(event) => { props.setQuickAttending(create.quickAttending()); }}>
        {'닫기'}
      </Button>
    </DialogActions>
  </>);
}

function UsableTicketsToAttend(props) {
  const classes = style.ticketsToAttend();

  const [ page, setPage ] = useState(1);
  const [ pageCount, setPageCount ] = useState(0);
  const [ quickNote, setQuickNote ] = useState('');
  const [ ticketToUse, setTicketToUse ] = useState(-1);
  const [ usableTickets, setUsableTickets ] = useState([]);
  const [ usedAt, setUsedAt ] = useState(Date.now());

  const { request, setSnackbarMessage } = props.context.getStates();

  const fetchTickets = useCallback((page) => {
    request.postSecurely('/attender/issued/usable', {
      attender: props.attender.rowid,
      page,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        if ('counts' in response) {
          var ticketCount = 0;
          for (const _counted of response.counts) {
            ticketCount += _counted['COUNT(*)'];
          }
          setPageCount(Math.ceil(ticketCount / 5));
        }
        if ('tickets' in response) {
          setUsableTickets(response.tickets);
        }
      }
    });
  }, [
    props.attender.rowid,
    request,
  ]);

  const quicklyAttend = (ticketToUse) => {
    request.postSecurely('/attender/issued/update', {
      note: quickNote,
      rowid: ticketToUse,
      usedAt,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        props.setQuickAttending(create.quickAttending());
        props.setRevision(props.revision + 1);
        setSnackbarMessage('티켓을 사용하였습니다.');
      }
    });
  };

  useEffect(() => {
    fetchTickets(page - 1);
  }, [fetchTickets, page]);

  return (<>
    <DialogContent className={classes.dialogContent}>
      {pageCount === 0 ? (
        <Typography variant="body1">
          {'사용 가능한 티켓이 없습니다.'}
        </Typography>
      ) : (<>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDateTimePicker format="yyyy/MM/dd hh:mm a" label={'사용일'}
            onChange={(datetime) => {
              setUsedAt(datetime.getTime());
            }}
            value={usedAt}
          />
        </MuiPickersUtilsProvider>

        <TableContainer>
          <Table>
            <TableBody>
              {usableTickets.map((ticket) => (
                <TableRow hover tabIndex={-1} key={ticket['issued.rowid']}>
                  <TableCell align={'left'} style={{padding: 5}}>
                    <FormControlLabel className={classes.formControlLabel}
                      label={(
                        <IssuedTicket ticket={create.issuedTicket({
                          activeFrom: ticket['ticket.active_from'],
                          activeUntil: ticket['ticket.active_until'],
                          color: ticket['ticket.color'],
                          name: ticket['ticket.name'],
                          note: ticket['issued.note'],
                          paidMethod: ticket['paid.method'],
                          rowid: ticket['issued.rowid'],
                          // "issued.date": 1643437200000
                        })} />
                      )}
                      control={<Radio checked={ticket['issued.rowid'] === ticketToUse}
                        onChange={(event) => {
                          setTicketToUse(parseInt(event.target.value));
                        }}
                        value={ticket['issued.rowid']}
                      />}
                    />
                  </TableCell>
                  <TableCell style={{padding: 5}}>
                    {ticket['issued.note'].split('\n').map((line, index) => (
                      <span key={index}>{line}<br/></span>
                    ))}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div className={classes.pagination}>
          <Pagination count={pageCount}
            onChange={(event, newPage) => { setPage(newPage); }}
          />
        </div>

        <TextField multiline rows={4} label={'비고'}
          onChange={(event) => { setQuickNote(event.target.value); }}
          value={quickNote}
        />
      </>)}
    </DialogContent>

    <DialogActions>
      <Button onClick={(event) => { props.setQuickAttending(create.quickAttending()); }}>
        {'닫기'}
      </Button>
      {pageCount > 0 && (
        <Button color="primary"onClick={(event) => { quicklyAttend(ticketToUse); }}>
          {'사용'}
        </Button>
      )}
    </DialogActions>
  </>);
}

export default function QuickAttending(props) {
  const classes = style.quickAttending();

  const { request, setPath, ticketer } = props.context.getStates();

  const [ attender, setAttender ] = useState(create.attender());
  const [ tab, setTab] = useState(0);

  const fetchAttender = useCallback(() => {
    if (attender.rowid > -1) {
      request.postSecurely('/attender/select', {
        attender: attender.rowid,
        ticketer,
      }, (response) => {
        if ('error' in response) {
          console.error(response);
        } else if ('attender' in response) {
          setAttender(create.attender(
            response.attender.rowid,
            response.attender.active,
            response.attender.birthdate,
            response.attender.email,
            response.attender.name,
            response.attender.note,
            response.attender.picture256,
            response.attender.phone,
          ));
        }
      });
    }
  }, [
    attender.rowid,
    request,
    ticketer,
  ])

  useEffect(() => {
    setAttender(create.attender(props.quickAttending.rowid));
  }, [props.quickAttending]);

  useEffect(() => {
    fetchAttender();
  }, [
    fetchAttender,
  ]);

  return (
    <Dialog fullWidth open={props.quickAttending.rowid > -1}>
      <AppBar position="static" color="default">
        <div className={classes.appBarAttender}>
          {attender.picture256 === '' ? (null) : (
            <img alt={''} height="192" width="192" className={classes.appBarAttenderPicture}
              src={'data:image/jpeg;base64,' + attender.picture256}
            />
          )}
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.appBarAttenderInfo}>{attender.name}</TableCell>
                  <TableCell className={classes.appBarAttenderInfo}>{attender.phone}</TableCell>
                  <TableCell align="right" className={classes.appBarAttenderInfo}>
                    <IconButton edge="start" color="inherit" size="small"
                      onClick={(event) => {
                        setPath(`/schedules/attender?id=${attender.rowid}`);
                      }}
                    ><OpenInNewIcon /></IconButton>
                  </TableCell>
                </TableRow>
                <TableRow>
                  {attender.note === '' ? (
                    <TableCell colSpan={3} className={classes.appBarAttenderInfo}>
                      <Typography variant="body1" color="textSecondary"
                      >{'-'}</Typography>
                    </TableCell>
                  ) : (
                    <TableCell colSpan={3} className={classes.appBarAttenderInfo}>
                      {attender.note.split('\n').map((line, index) => (
                        <Typography variant="body1" key={index}
                          color="textSecondary"
                        >{line}</Typography>
                      ))}
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <Tabs value={tab}
          indicatorColor="primary"
          onChange={(event, newTab) => { setTab(newTab); }}
          scrollButtons="auto"
          textColor="primary"
          variant="scrollable"
        >
          <Tab label="잔여 티켓" />
          <Tab label="티켓 사용 내역" />
          <Tab label="결제 내역" />
        </Tabs>
      </AppBar>

      {tab === 0 && (
        <UsableTicketsToAttend attender={attender}
          context={props.context}
          revision={props.revision}
          setAttender={setAttender}
          setQuickAttending={props.setQuickAttending}
          setRevision={props.setRevision}
        />
      )}
      {tab === 1 && (
        <UsedTicketsToAttend attender={attender}
          context={props.context}
          setQuickAttending={props.setQuickAttending}
        />
      )}
      {tab === 2 && (
        <QuickPayments attender={attender}
          context={props.context}
          setQuickAttending={props.setQuickAttending}
        />
      )}
    </Dialog>
  );
}
